module.exports = __webpack_public_path__ + "static/media/hakusteel-5.fe34d5cc.png";